import { render, staticRenderFns } from "./TheLeft.vue?vue&type=template&id=34e75b47&scoped=true"
import script from "./TheLeft.vue?vue&type=script&lang=js"
export * from "./TheLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e75b47",
  null
  
)

export default component.exports